import { defineStore } from "pinia"

export const useshopchartinfo = defineStore('chartinfo', {
    // defineStore(id(一个储存库标识))
    state: () => ({
        hid: null,
        companyCode: null,
        materialList:[]
    }),
    persist: true,
})